import { initialState } from "reducers/Reports/State";
import { ReportsInfo } from "constants/Actions";
import { setMenuLabels } from "functions";

const { GET_REPORT_INFO, GET_REPORT_INFO_SUCCESS, GET_REPORT_INFO_FAIL } =
  ReportsInfo;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_REPORT_INFO:
      return Object.assign({}, state, {
        reportsList: [],
        reportsLoading: true,
      });
    case GET_REPORT_INFO_SUCCESS:
      return Object.assign({}, state, {
        reportsList: payload?.data,
        reportsLoading: false,
        ...setMenuLabels(payload?.data),
      });
    case GET_REPORT_INFO_FAIL:
      return Object.assign({}, state, {
        reportsList: [],
        reportsLoading: false,
      });
    default:
      return state;
  }
};
